var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJar6(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 483 709",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M392.07 180.93H89.03L29.86 298.25a56.12 56.12 0 00-6.85 26.85v262.77c0 56.19 45.55 101.74 101.74 101.74h234.86c56.19 0 101.74-45.55 101.74-101.74V325.41c0-9.58-2.45-19-7.13-27.36l-62.14-117.12h-.01z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M336.26 13.46H140.51c-52.848 0-95.69 42.842-95.69 95.69v33.9c0 52.848 42.842 95.69 95.69 95.69h195.75c52.848 0 95.69-42.842 95.69-95.69v-33.9c0-52.848-42.842-95.69-95.69-95.69z",
    fill: "#FD934F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.03 6.42H122.48c-43.79 0-79.29 35.497-79.29 79.285s35.5 79.285 79.29 79.285h228.55c43.791 0 79.29-35.497 79.29-79.285S394.821 6.42 351.03 6.42z",
    fill: "#FED425"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.11 565.15H85.24c-34.369 0-62.23 27.861-62.23 62.23s27.861 62.23 62.23 62.23h313.87c34.369 0 62.23-27.861 62.23-62.23s-27.861-62.23-62.23-62.23z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M296.21 73.05h-107c-9.45 0-17.11 7.66-17.11 17.11v1.93c0 9.449 7.66 17.11 17.11 17.11h107c9.45 0 17.11-7.661 17.11-17.11v-1.93c0-9.45-7.66-17.11-17.11-17.11z",
    fill: "#2A848E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M382.22 578.09H107.44c-18.993 0-34.39 15.397-34.39 34.39v5.36c0 18.993 15.397 34.39 34.39 34.39h274.78c18.993 0 34.39-15.397 34.39-34.39v-5.36c0-18.993-15.397-34.39-34.39-34.39z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 15.09,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.96 281.26v326.08c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-324.9l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M124.16 300.35c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M162.35 535.77c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M162.35 499.49c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M162.35 464.22c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M162.35 428.53c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M162.35 391.84c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M162.35 353.99c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M162.35 316.12c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M162.35 573.04c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.12 281.26v326.08c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-324.9l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M203.31 300.35c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M241.51 535.77c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M241.51 499.49c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M241.51 464.22c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M241.51 428.53c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M241.51 391.84c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M241.51 353.99c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M241.51 316.12c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M241.51 573.04c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M246.83 281.26v326.08c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-324.9l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M285.03 300.35c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M323.23 535.77c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M323.23 499.49c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M323.23 464.22c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M323.23 428.53c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M323.23 391.84c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M323.23 353.99c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M323.23 316.12c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M323.23 573.04c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M325.99 281.26v326.08c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-324.9L326 281.27l-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19 300.35c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M402.39 535.77c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M402.39 499.49c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M402.39 464.22c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M402.39 428.53c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M402.39 391.84c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M402.39 353.99c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M402.39 316.12c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M402.39 573.04c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M387.29 357.92v-32.5c0-9.58-2.45-19-7.13-27.36l-11.99-22.6M387.29 529.62V421.3",
    stroke: "#FBFDFE",
    strokeWidth: 27.97,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M222.304 369.995l-51.541-51.541a7.981 7.981 0 00-11.286 0l-51.541 51.541a7.981 7.981 0 000 11.286l51.541 51.541a7.981 7.981 0 0011.286 0l51.541-51.541a7.981 7.981 0 000-11.286z",
    fill: "#9FFC27",
    stroke: "#7ABA1E",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M130.09 378.13h31.52c1.94 0 3.51-1.57 3.51-3.51v-30.64c0-3.1-3.73-4.68-5.96-2.52l-31.52 30.64c-2.26 2.2-.7 6.03 2.45 6.03z",
    fill: "#EFFFD7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M370.504 542.575l-51.541-51.541a7.98 7.98 0 00-11.285 0l-51.541 51.541a7.98 7.98 0 000 11.286l51.541 51.541a7.98 7.98 0 0011.285 0l51.541-51.541a7.98 7.98 0 000-11.286z",
    fill: "#FF1F4F",
    stroke: "#DD0A41",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M278.3 550.71h31.52c1.94 0 3.51-1.57 3.51-3.51v-30.64c0-3.1-3.73-4.68-5.96-2.52l-31.52 30.64c-2.26 2.2-.7 6.03 2.45 6.03z",
    fill: "#EFFFD7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.01 636.38c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M111.76 636.38c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52zM164.01 593.75c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M185.68 552.65c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M213.34 513.7c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M243.23 481.84c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M270.89 442.89c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M304.73 409.05c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M304.73 360.32c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M304.73 313.34c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJar6);
export default ForwardRef;